export default __webpack_public_path__ + "static/media/for_sale_inset_pic.77dc4993.jpg";